<template>
  <content-container title="自由合同" :table-row-count="tableData.length">
    <!-- 搜索条件区域 -->
    <search-container>
      <search-col>
        <el-input v-model="params.contractNo" placeholder="合同编号" clearable @keydown="onEnter" />
      </search-col>
      <search-col>
        <el-input v-model="params.contractSubject" placeholder="合同主题" clearable @keydown="onEnter" />
      </search-col>
      <search-col>
        <el-select
          v-model="params.status"
          placeholder="状态"
          clearable
        >
          <el-option :label="contractCreateStatusConfig[EContractCreateStatus.TO_BE_SIGNED]" :value="EContractCreateStatus.TO_BE_SIGNED" />
          <el-option :label="contractCreateStatusConfig[EContractCreateStatus.SIGNING]" :value="EContractCreateStatus.SIGNING" />
          <el-option :label="contractCreateStatusConfig[EContractCreateStatus.COMPLETED]" :value="EContractCreateStatus.COMPLETED" />
          <el-option :label="contractCreateStatusConfig[EContractCreateStatus.REVOKED]" :value="EContractCreateStatus.REVOKED" />
          <el-option :label="contractCreateStatusConfig[EContractCreateStatus.ALREADY_OVERDUE]" :value="EContractCreateStatus.ALREADY_OVERDUE" />
          <el-option :label="contractCreateStatusConfig[EContractCreateStatus.TERMINATED]" :value="EContractCreateStatus.TERMINATED" />
          <el-option :label="contractCreateStatusConfig[EContractCreateStatus.VOIDED_IN_PROGRESS]" :value="EContractCreateStatus.VOIDED_IN_PROGRESS" />
          <el-option :label="contractCreateStatusConfig[EContractCreateStatus.INVALID]" :value="EContractCreateStatus.INVALID" />
          <el-option :label="contractCreateStatusConfig[EContractCreateStatus.EXPIRED]" :value="EContractCreateStatus.EXPIRED" />
        </el-select>
      </search-col>
      <!-- <search-col>
        <el-select
          v-model="params.initiator"
          placeholder="发起方"
          clearable
        >
          <el-option
            v-for="item in initiatorOption"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
      </search-col> -->
      <search-col>
        <el-select
          v-model="params.actor"
          placeholder="签署方"
          clearable
          filterable
        >
          <el-option
            v-for="item in actorOption"
            :key="item.actorName"
            :label="item.actorName"
            :value="item.platformId"
          />
        </el-select>
      </search-col>
      <search-col v-if="isSaas || isServer">
        <el-select
          v-model="params.unSignedActor"
          placeholder="待签署方"
          clearable
          filterable
        >
          <el-option
            v-for="item in actorOption"
            :key="item.actorName"
            :label="item.actorName"
            :value="item.platformId"
          />
        </el-select>
      </search-col>
      <search-col>
        <el-date-picker
          v-model="dateRange1"
          style="width: 100%;"
          type="daterange"
          value-format="YYYY-MM-DD HH:mm:ss"
          format="YYYY-MM-DD"
          :default-time="defaultTimeFormat"
          start-placeholder="发起时间(起)"
          end-placeholder="发起时间(止)"
          @keydown="onEnter"
        />
      </search-col>
      <search-col>
        <el-date-picker
          v-model="dateRange2"
          style="width: 100%;"
          type="daterange"
          value-format="YYYY-MM-DD HH:mm:ss"
          format="YYYY-MM-DD"
          :default-time="defaultTimeFormat"
          start-placeholder="截止时间(起)"
          end-placeholder="截止时间(止)"
          @keydown="onEnter"
        />
      </search-col>
      <search-col>
        <el-date-picker
          v-model="dateRange3"
          style="width: 100%;"
          type="daterange"
          value-format="YYYY-MM-DD HH:mm:ss"
          format="YYYY-MM-DD"
          :default-time="defaultTimeFormat"
          start-placeholder="完成时间(起)"
          end-placeholder="完成时间(止)"
          @keydown="onEnter"
        />
      </search-col>
      <search-col>
        <el-date-picker
          v-model="dateRange4"
          style="width: 100%;"
          type="daterange"
          value-format="YYYY-MM-DD HH:mm:ss"
          format="YYYY-MM-DD"
          :default-time="defaultTimeFormat"
          start-placeholder="合同到期(起)"
          end-placeholder="合同到期(止)"
          @keydown="onEnter"
        />
      </search-col>
      <search-col>
        <el-input v-model="params.remark" placeholder="备注" clearable @keydown="onEnter" />
      </search-col>

      <template #buttons>
        <el-button @click="resetForm">
          <svg-icon icon="tabler:refresh" />重置
        </el-button>
        <el-button type="primary" @click="doSearch">
          <svg-icon icon="lucide:search" />查询
        </el-button>
      </template>
    </search-container>

    <!-- 非搜索区域的额外按钮 -->
    <div>
      <el-button v-permission="['contract:initiate:add']" type="primary" class="mb-[20px]" @click="toAdd">
        <svg-icon icon="lucide:circle-plus" />创建合同
      </el-button>
      <el-button class="mb-[20px]" @click="exportTable">
        <svg-icon icon="mingcute:file-export-line" />导出
      </el-button>
      <el-button class="mb-[20px]" @click="downnloadContract">
        <svg-icon icon="mingcute:file-export-line" />下载合同
      </el-button>
    </div>

    <!-- 表格数据 -->
    <el-table v-loading="loading" class="normal-table" :border="true" :scrollbar-always-on="true" :data="tableData" :cell-style="initOperatorColumnStyle" tooltip-effect="dark nhb-max-w-500">
      <el-table-column align="center" type="selection" :min-width="55" />
      <el-table-column align="left" prop="contractNo" label="合同编号" :min-width="140" show-overflow-tooltip />
      <el-table-column align="left" prop="contractSubject" label="合同主题" :min-width="140" show-overflow-tooltip />
      <el-table-column align="center" prop="status" label="状态" :min-width="100" show-overflow-tooltip>
        <template #default="scope">
          <custom-tag :label="contractCreateStatusConfig[scope.row.status]" :type="contractCreateStatusStyle[scope.row.status]" />
        </template>
      </el-table-column>
      <el-table-column align="left" prop="initiator" label="发起方" :min-width="140" show-overflow-tooltip>
        <template #default="scope">
          {{ scope.row.initiator || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="actor" label="签署方" :min-width="100" show-overflow-tooltip>
        <template #default="scope">
          <el-popover
            placement="bottom-start"
            :title="`签署方（${currentRowActorInfo.length}）`"
            width="375"
            trigger="click"
          >
            <template #reference>
              <el-link type="primary" :underline="false" @click="handleClickSearch(scope.row)">
                查看
              </el-link>
            </template>
            <ul>
              <li v-for="item in currentRowActorInfo" :key="item.name" class="flex justify-between border-solid border-b border-[#EBEEF5]  h-10 items-center">
                <div class="w-[157px]">
                  {{ item.name }}
                </div> <el-link :type="contractSignStatusStyle[Number(item.status)]" :underline="false">
                  ● {{ contractSignStatusConfig[Number(item.status)] }}
                </el-link>
              </li>
            </ul>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column v-if="isSaas || isServer" align="center" prop="unSignedActorNames" label="待签署方" :formatter="(row) => isNull(row.unSignedActorNames) ? '--' : row.unSignedActorNames" :min-width="120" show-overflow-tooltip />
      <el-table-column align="left" prop="remark" label="备注" :min-width="140" show-overflow-tooltip>
        <template #default="scope">
          {{ scope.row.remark || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="left" prop="createTime" label="发起时间" :min-width="170" show-overflow-tooltip>
        <template #default="scope">
          {{ scope.row.createTime || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="left" prop="endTime" label="截止时间" :min-width="170" show-overflow-tooltip>
        <template #default="scope">
          {{ scope.row.endTime || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="left" prop="finishTime" label="完成时间" :min-width="170" show-overflow-tooltip>
        <template #default="scope">
          {{ scope.row.finishTime || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="left" prop="expireTime" label="合同到期时间" :min-width="170" show-overflow-tooltip>
        <template #default="scope">
          {{ scope.row.expireTime || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="left" prop="creator" label="创建者" :min-width="80" show-overflow-tooltip />
      <el-table-column
        v-if="buttons.length > 0"
        align="center"
        prop="actions"
        fixed="right"
        label="操作"
      >
        <template #default="scope">
          <table-row-buttons :buttons="buttons" :row="scope.row" />
        </template>
      </el-table-column>
    </el-table>

    <!-- 底部分页 -->
    <template #footer>
      <el-pagination
        v-model:current-page="params.page"
        v-model:page-size="params.size"
        :page-sizes="[defaultPageSize, 25, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
        @size-change="onSizeChange"
        @current-change="onCurrentPageChange"
      />
    </template>

    <extension :row="currentRow" :visible="extensionDialogVisible" @close="handleCloseExtensionDialog" />

    <revoke :row="currentRow" :visible="revokeDialogVisible" @close="handleCloseRevokeDialog" />

    <invalidate :row="currentRow" :visible="invalidateDialogVisible" @close="handleCloseInvalidateDialog" />
  </content-container>
</template>

<script setup lang="ts">
import { downloadFile, getFomattedTimeRange, isNull } from '@core/tools';
import { reactive, ref, PropType, computed } from 'vue';
import { ElMessage } from 'element-plus';
import Extension from './dialog/Extension.vue';
import Revoke from './dialog/Revoke.vue';
import Invalidate from './dialog/Invalidate.vue';
import { SvgIcon, CustomTag, TableRowButtons, initOperatorColumnStyle } from '@vue3/components';
import { ContentContainer, SearchContainer, SearchCol, useTblPermissionButtons, queryContractCreateMypage, queryContractCreateDownload, queryContractCreateDrapDown, contractCreateExport, queryContractCreatePreview, queryContractCreateActorInfo } from '../../../..';
import {
  contractCreateStatusConfig,
  contractCreateStatusStyle,
  IContractCreatePage,
  contractSignStatusConfig,
  contractSignStatusStyle,
  IContractActorListVO,
  EContractCreateStatus,
  IContractCreatePageParams,
} from '../../../../types/contracts/contracts';
import { useRouter } from 'vue-router';

defineOptions({ name: 'FreeContract' });

const props = defineProps({
  from: {
    type: String as PropType<'saas' | 'company' | 'agent' | 'server'>,
    default: 'saas',
  },
});

const router = useRouter();

const defaultTimeFormat = computed (() => getFomattedTimeRange());
const isSaas = computed(() => props.from === 'saas');
const isServer = computed(() => props.from === 'server');

const defaultPageSize = 10;
const params = reactive<IContractCreatePageParams>({
  page: 1,
  size: defaultPageSize,
  contractType: 1,
});

const loading = ref(false);
const total = ref(0);
const tableData = ref<IContractCreatePage[]>([]);
const dateRange1 = ref<string[]>([]);
const dateRange2 = ref<string[]>([]);
const dateRange3 = ref<string[]>([]);
const dateRange4 = ref<string[]>([]);

const extensionDialogVisible = ref(false);
const revokeDialogVisible = ref(false);
const invalidateDialogVisible = ref(false);
const currentRow = ref<IContractCreatePage>({} as IContractCreatePage);
const contractIds = ref([] as number[]);
const actorOption = ref([]);

const currentRowActorInfo = ref<IContractActorListVO[]>([]);

const { buttons } = useTblPermissionButtons([
  {
    name: '编辑',
    code: '',
    relationField: 'showEdit',
    relationValue: true,
    action: handleEdit,
  },
  {
    name: '详情',
    code: '',
    action: goToContractSettingDetail,
  },
  {
    name: '预览',
    action: toPreview,
  },
  {
    name: '下载',
    action: toDownload,
  },
  {
    name: '延期',
    code: 'contract:initiate:operate',
    relationField: 'showExtension',
    relationValue: true,
    action: toExtension,
  },
  {
    name: '撤销',
    code: 'contract:initiate:operate',
    relationField: 'showRevoke',
    relationValue: true,
    action: toRevoke,
  },
  {
    name: '作废',
    code: 'contract:initiate:operate',
    relationField: 'showInvalidate',
    relationValue: true,
    action: toInvalidate,
  },
]);

function toAdd() {
  router.push({
    name: 'InitiateContract',
    query: {
      from: 'free',
      contractType: 1,
    },
  });
}

async function exportTable() {
  try {
    const res = await contractCreateExport(params);

    downloadFile(res, '', 'xlsx');
    ElMessage.success('导出成功');
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function downnloadContract() {
  contractIds.value = tableData.value.map((v) => v.id);

  if (contractIds.value.length === 0) return ElMessage.warning('请先选择需要下载的合同');

  try {
    const url = await queryContractCreateDownload({
      ...params,
      ids: contractIds.value,
    });

    window.open(url);
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

}

async function toPreview(row) {
  try {
    const res = await queryContractCreatePreview(row.id);

    window.open(res);
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function goToContractSettingDetail(row) {
  router.push({
    name: 'ContractDetail',
    query: {
      from: 'all',
      contractType: row.contractType,
      contractId: row.id,
    },
  });

}
async function handleClickSearch(row) {
  currentRow.value = row;
  try {
    const res = await queryContractCreateActorInfo(row.id);

    currentRowActorInfo.value = res;
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function toDownload(row) {
  try {
    const url = await queryContractCreateDownload({
      page: 1,
      size: 10,
      ids: [row.id],
    });

    window.open(url);
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}
// 延期
function toExtension(row) {
  currentRow.value = row;
  extensionDialogVisible.value = true;
}
// 撤销
function toRevoke(row) {
  currentRow.value = row;
  revokeDialogVisible.value = true;
}
// 作废
function toInvalidate(row) {
  currentRow.value = row;
  invalidateDialogVisible.value = true;
}

async function fetchData() {
  loading.value = true;

  try {
    const { data, total: all } = await queryContractCreateMypage({
      ...params,
      createStartTime: dateRange1.value?.[0],
      createEndTime: dateRange1.value?.[1],
      endTimeStart: dateRange2.value?.[0],
      endTimeEnd: dateRange2.value?.[1],
      finishTime: dateRange3.value?.[0],
      finishTimeEnd: dateRange3.value?.[1],
      expireTimeStart: dateRange4.value?.[0],
      expireTimeEnd: dateRange4.value?.[1],
    });

    tableData.value = data;
    total.value = all;
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

  loading.value = false;
}

function resetForm() {
  dateRange1.value = [];
  dateRange2.value = [];
  dateRange3.value = [];
  dateRange4.value = [];
  for (const key in params) {
    if (!['page', 'size'].includes(key)) {
      params[key] = '';
    }
  }
}

function onSizeChange(size: number) {
  params.size = size;
  params.page = 1;
  fetchData();
}

function onCurrentPageChange(page: number) {
  params.page = page;
  fetchData();
}

function doSearch() {
  params.page = 1;
  fetchData();
}

function onEnter(e) {
  if (e.keyCode === 13) doSearch();
}

function handleCloseExtensionDialog() {
  extensionDialogVisible.value = false;
  fetchData();
}
function handleCloseRevokeDialog() {
  revokeDialogVisible.value = false;
  fetchData();
}
function handleCloseInvalidateDialog() {
  invalidateDialogVisible.value = false;
  fetchData();
}

async function fetchDrapDownCreate() {
  try {
    const { actorList } = await queryContractCreateDrapDown();

    actorOption.value = actorList;
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

function handleEdit(row) {
  router.push({
    name: 'InitiateContract',
    query: {
      from: 'free',
      contractType: row.contractType,
      contractId: row.id,
    },
  });
}

async function init() {
  await fetchData();
  await fetchDrapDownCreate();
}

init();

</script>
